import React from 'react';

import { Color } from 'common';

import { keyedList } from 'utils';
import { _R } from 'utils/format';

export const colored = (text, color) => text != null && <span className={`d2-color-${color}`}>{text}</span>;

export default class TooltipBuilder {
  headerLine = null;
  body = [];

  constructor(name, value) {
    if (name) this.header(name, value);
  }

  build() {
    return (
      <div>
        {this.headerLine}
        {keyedList(this.body)}
      </div>
    );
  }

  empty() {
    return this.body.length === 0;
  }

  header(name, value) {
    if (value != null) name = _R`${name}: ${colored(value, Color.BLUE)}`;
    this.headerLine = <p className="d2p-header">{colored(name, Color.GOLD)}</p>;
    return this;
  }

  line(text, bullet=true) {
    this.body.push((
      <p>
        {!!bullet && <span className="d2p-bullet"/>}
        {text}
      </p>
    ));
    return this;
  }

  prepend(text, bullet=true) {
    this.body.unshift((
      <p>
        {!!bullet && <span className="d2p-bullet"/>}
        {text}
      </p>
    ));
    return this;
  }

  add(lines) {
    if (!lines) return this;
    if (typeof lines === 'string') {
      let bullet = true;
      if (lines[0] === '@') {
        lines = lines.substring(1);
        bullet = false;
      }
      this.line(lines, bullet);
    } else if (lines instanceof Array) {
      for (const line of lines) {
        this.add(line);
      }
    } else if (lines instanceof TooltipBuilder) {
      this.body.push(...lines.body);
    }
    return this;
  }

  table(columns, values, highlight, sections=1) {
    const header = [...columns];
    for (let i = 1; i < sections; ++i) {
      header.push('', ...columns);
    }
    const numRows = Math.ceil(values.length / sections);
    this.body.push(
      <table className={`d2p-col${sections}`}>
        <thead>
          <tr>{header.map((c, i) => <th key={i}>{c}</th>)}</tr>
        </thead>
        <tbody>
          {[...Array(numRows)].map((_, i) => {
            function cell(pos, data, index) {
              const cls = (highlight?.(data, index) ? 'd2p-highlight' : null);
              return data.map((val, p) => <td key={pos + p} className={cls}>{val}</td>);
            }
            const row = cell(0, values[i], i);
            for (let j = 1; j < sections; ++j) {
              const index = i + j * numRows;
              if (index < values.length) {
                row.push(<td key={row.length}/>);
                row.push(...cell(row.length, values[index], index));
              }
            }
            return <tr key={i}>{row}</tr>;
          })}
        </tbody>
      </table>
    );
  }
}
